import { api } from '..'
import { TDeviceGroupItem } from 'shared/types'
import { useQuery } from '@tanstack/react-query'

export const getDeviceGroup = (deviceGroupId: string) =>
  api
    .get<TDeviceGroupItem>(`/v1/device-group/${deviceGroupId}`)
    .then(({ data }) => data)

export const useGetDeviceGroup = (deviceGroupId?: string) => {
  return useQuery({
    queryFn: () => getDeviceGroup(deviceGroupId!),
    queryKey: ['deviceGroups', deviceGroupId],
    enabled: !!deviceGroupId,
  })
}
